.container {
  flex-item: 1 auto;
  margin: 12px;
}
.container.normal {
  width: 240px;
}
.container.small {
  width: 120px;
}

.contents {
  background-color: #eee;
  border-radius: 6px;
  box-shadow: 1px 1px 4px #888;
  position: relative;
}
.contents.normal {
  height: 300px;
}
.contents.small {
  height: 210px;
}

:global(.dark) .contents {
  background-color: #444;
  box-shadow: -1px -1px 4px #666;
  color: #ddd;
}

.picture {
  position: absolute;
  top: 0;
  left: 0;
  background-size: 240px 240px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 1px 0px 8px #222;
}
.picture.normal {
  width: 240px;
  height: 240px;
}
.picture.small {
  width: 120px;
  height: 120px;
}
.picture.ingredient {
  background-color: var(--ingredient-color-back);
}
.picture.meal {
  background-color: var(--meal-color-back);
}

.name {
  position: absolute;
  font-family: Rubik;
  text-shadow: 0 0 4px #222;
  text-align: center;
  width: 100%;
  top: 10px;
  font-weight: 500;
}
.name.normal {
  font-size: 18px;
  padding: 4px 8px;
  line-height: 18px;
}
.name.small {
  font-size: 16px;
  padding: 2px 4px;
  line-height: 16px;
}
.name.plus:before {
  color: rgb(84.7619047619%, 88.5714285714%, 84.7619047619%);
  content: attr(data-text);
  position: absolute;
  -webkit-text-stroke: 0.03em rgb(27.1428571429%, 36.1904761905%, 27.1428571429%);
  left: 0;
  top: 0;
  width: 100%;
  padding: inherit;
  font-weight: 500;
}
.name.meal:before {
  color: #ccbbbb;
  content: attr(data-text);
  position: absolute;
  -webkit-text-stroke: 0.03em rgb(19.0476190476%, 14.2857142857%, 14.2857142857%);
  left: 0;
  top: 0;
  width: 100%;
  padding: inherit;
  font-weight: 500;
}
.name.meal .match {
  background-color: #886666;
}
.name.ingredient:before {
  color: rgb(83.5897435897%, 83.5897435897%, 63.0769230769%);
  content: attr(data-text);
  position: absolute;
  -webkit-text-stroke: 0.03em rgb(39.2307692308%, 39.2307692308%, 17.4358974359%);
  left: 0;
  top: 0;
  width: 100%;
  padding: inherit;
  font-weight: 500;
}
.name.ingredient .match {
  background-color: rgb(74.358974359%, 74.358974359%, 42.3076923077%);
}

.info {
  position: absolute;
  left: 0;
  font-size: 12;
  padding: 4px;
}
.info.normal {
  top: 240px;
}
.info.small {
  top: 120px;
}

.infoTable {
  display: flex;
  flex-flow: column wrap;
  font-size: 11px;
  margin-top: 4px;
}

.infoEntry {
  flex-item: 1 auto;
  margin-left: 6px;
  white-space: nowrap;
  line-height: 18px;
}
.infoEntry.normal {
  width: 120px;
}
.infoEntry.small {
  width: 60px;
}

.infoLabel {
  margin-left: 6px;
  color: #444;
}

:global(.dark) .infoLabel {
  color: #ccc;
}

.infoData {
  margin-left: 6px;
  color: #000;
}

:global(.dark) .infoData {
  color: #fff;
}

.infoIcon {
  font-size: 9px;
}
.infoIcon.plus {
  color: #686;
}
.infoIcon.meal {
  color: #866;
}
.infoIcon.ingredient {
  color: #994;
}

.dropdown {
  position: absolute;
  right: 6px;
  bottom: 6px;
}

.plusCard {
  position: absolute;
  display: block;
  background-color: var(--plus-color-back);
  border-radius: 6px;
  cursor: pointer;
}
.plusCard.normal {
  width: 240px;
  height: 300px;
}
.plusCard.small {
  width: 120px;
  height: 210px;
}

.plusIcon {
  display: block;
  color: var(--plus-color-icon);
  position: absolute;
}
.plusIcon.normal {
  width: 240px;
  text-align: center;
  top: 80px;
  font-size: 60px;
  text-shadow: -1px -1px 3px #242 1px 1px 1px #cec;
  top: 90px;
}
.plusIcon.small {
  width: 120px;
  text-align: center;
  top: 40px;
  font-size: 30px;
  text-shadow: -1px -1px 3px #242 1px 1px 1px #cec;
  top: 60px;
}

.plusName {
  width: 100%;
  color: rgb(84.7619047619%, 88.5714285714%, 84.7619047619%);
  font-family: Lato;
  font-weight: normal;
  position: absolute;
  text-align: center;
  color: rgb(84.7619047619%, 88.5714285714%, 84.7619047619%);
  font-size: 18px;
}
.plusName.normal {
  top: 170px;
}
.plusName.small {
  top: 105px;
}

.modelIcon {
  position: absolute;
  top: -15px;
}
.modelIcon.normal {
  width: 240px;
  text-align: center;
  top: 80px;
  font-size: 60px;
}
.modelIcon.small {
  width: 120px;
  text-align: center;
  top: 40px;
  font-size: 30px;
}
.modelIcon.meal {
  text-shadow: -1px -1px 3px #999 1px 1px 1px rgb(19.0476190476%, 14.2857142857%, 14.2857142857%);
  color: #866;
}
.modelIcon.ingredient {
  text-shadow: -1px -1px 3px #999 1px 1px 1px rgb(39.2307692308%, 39.2307692308%, 17.4358974359%);
  color: #994;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */